angular.module('impactx.disposition').controller('DispositionWaitDialogCtrl', [
    '$scope',
    'dataGen',
    '$mdDialog',
    'dispositionId',
    DispositionWaitDialogCtrl]);

function DispositionWaitDialogCtrl($scope, dataGen, $mdDialog, dispositionId)
{
    dataGen.getData($scope, {dispositionId: dispositionId},"/disposition/dispositionwaititem");
    $scope.addItemsToBasket = function()
    {
        var dataObj = {
            dispositionId: dispositionId
        };
        dataGen.post($scope, dataObj, "/disposition/dispositionaddtobasket", function ()
        {
            $mdDialog.hide(true);
        });
    };
    $scope.hide = function ()
    {
        $mdDialog.hide();
    };
    $scope.cancel = function ()
    {
        $mdDialog.cancel();
    };
    $scope.answer = function (answer)
    {
        $mdDialog.hide(answer);
    };
}